import React from 'react';
import styled from 'styled-components';
import { SellerMainBadge } from '../molecules/sellerMainBadge';
import { SellerInfo } from '../molecules/sellerInfo';
import { SellerHighlight } from '../molecules/sellerHighlight';

type DispatchMetrics = (event: string, data: { [key: string]: string }) => void;

interface SellerReputationProps {
  hasBadgeCustomCare: boolean;
  hasBadgeFastDelivery: boolean;
  hasBadgeSalesVolume: boolean;
  dispatchMetrics: DispatchMetrics;
  salesRange: {
    range: string;
  };
  badge: {
    image: string;
    title: string;
    description: string;
  };
  seller: {
    image: string;
    name: string;
    location: string;
  };
}

export const Card = ({
  seller,
  badge,
  salesRange,
  hasBadgeSalesVolume,
  hasBadgeCustomCare,
  hasBadgeFastDelivery,
  ...props
}: SellerReputationProps) => (
  <Wrapper>
    <SellerInfo {...seller} hasBadgeSalesVolume={hasBadgeSalesVolume} />
    {hasBadgeSalesVolume && (
      <>
        {badge && <SellerMainBadge {...badge} />}
        <SellerHighlight
          {...salesRange}
          {...props}
          hasMainBadge={!!badge}
          hasBadgeCustomCare={hasBadgeCustomCare}
          hasBadgeFastDelivery={hasBadgeFastDelivery}
        />
      </>
    )}
  </Wrapper>
);

const Wrapper = styled.div`
  width: 328px;
  border: 1px solid #f1f1f1;
  border-radius: 16px;
  margin-bottom: 16px;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    width: auto;
    margin: 0 16px 8px;
  }
`;
